import React from "react";
// import logoImg from "../../../assets/images/logo.png";
import logoImg from "../../../assets/images/login-t-logo.svg";
import './auth.css';

const AuthHeaderPage = () => {
    return (
        <header className="auth-header">
            <h4 className="text-white">ANALYSTIC PRO</h4>
            <div className="d-flex flex-column align-items-center pt-5 pe-4">
                <img src={logoImg}></img>
                {/* <p>Powered by T-Systems</p> */}
            </div>
        </header>
    );
};
export default AuthHeaderPage;
